import axios from 'axios'

export default {
    namespaced: true,
    state: {
        emaApplicationAttachments: [],
        emaApplicationAttachment: {},
    },
    mutations: {
        SET_EMA_APPLICATION_ATTACHMENTS(state, payload) {
            state.emaApplicationAttachments = payload;
        },
        SET_EMA_APPLICATION_ATTACHMENT(state, payload) {
            state.emaApplicationAttachment = payload;
        },
    },
    actions: {
        async FetchEMAApplicationAttachments({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/attachments/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_EMA_APPLICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchEMAApplicationAttachments: ${error.message}`));
            });
        },
        async FetchEMAApplicationAttachment({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/attachments/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_EMA_APPLICATION_ATTACHMENT', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchEMAApplicationAttachment: ${error.message}`));
            });
        },
        async InsertEMAApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/attachments/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertEMAApplicationAttachment: ${error.message}`));
            });
        },
        async DeleteEMAApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/attachments/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteEMAApplicationAttachment: ${error.message}`));
            });
        },
    },
    getters: {
        EMAApplicationAttachments(state) { return state.emaApplicationAttachments; },
        EMAApplicationAttachment(state) { return state.emaApplicationAttachment; },
    }
}
